import { AfterViewInit, Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  CreditCardExpirationStatusType,
  PaymentMethodAccountType,
  PaymentMethodAccountUseType
} from 'libs/billing/payment-method/util/src/lib/models/payment-method-util.models';
import { map, Observable, of, take } from 'rxjs';
import { v4 as uuidv4 } from 'uuid';

import { BillAccountsSelectors } from '@amfam/billing/billaccount/data-access';
import { BrandSelectors } from '@amfam/shared/utility/brand';
import { CopyService } from '@amfam/shared/utility/shared-services';
import { DsModalService, LoadingSpinnerService } from '@amfam/ui-kit';

import { PaymentMethodFeatureActions } from '../..';
import AfeFinancialEntryAdapter, {
  AfeTokenResponseType,
  CreditCardEntryOptionsType
} from './CardEntryAdapter';

@Component({
  selector: 'ds-hs-add-credit-debit-card-modal',
  templateUrl: './hs-add-credit-debit-card.component.html',
  styleUrl: './hs-add-credit-debit-card.component.scss',
  standalone: false
})
export class HsAddCreditDebitCardModalComponent implements OnInit, AfterViewInit {
  primaryButtonName: string;
  cardEntryAdapterRef: AfeFinancialEntryAdapter;
  experienceId: string;
  sessionId = uuidv4();
  isHsPolicy$: Observable<boolean>;
  isValid$: Observable<boolean> = of(false);

  private partnerId: string;

  constructor(
    private copyService: CopyService,
    private modalService: DsModalService,
    private store: Store,
    private spinner: LoadingSpinnerService
  ) {}

  ngAfterViewInit(): void {
    const cardEntryAdapterOptions: CreditCardEntryOptionsType = {
      iframeContainerId: 'iframe-container',
      iframeId: 'cc-iframe',
      iframeName: 'cciframe',
      iframeClassArray: ['cc-iframe'],
      environment: 'dev', //env.environment,
      expId: 'MY_ACCOUNT', //'7146', //this.experienceId,// env.afiExperienceId,//'2860', //
      afeSessionId: this.sessionId,
      debug: true,
      onLoadComplete: this.onLoadComplete.bind(this),
      onValidation: this.onValidation.bind(this),
      onTokenSuccess: this.onTokenSuccess.bind(this),
      onTokenFailure: this.onTokenFailure.bind(this),
      paymentMethod: 'CC'
    };

    this.cardEntryAdapterRef = new AfeFinancialEntryAdapter(cardEntryAdapterOptions);
  }
  onLoadComplete() {
    this.spinner.stop();
  }
  onValidation(isFormValid: boolean) {
    this.isValid$ = of(isFormValid);
  }

  onTokenFailure() {
    this.isValid$ = of(false);
  }

  onTokenSuccess = (iframeResponse: AfeTokenResponseType) => {
    this.store.dispatch(
      PaymentMethodFeatureActions.storeAddPaymentMethodTokenInfo({
        paymentMethodInfo: {
          paymentMethod: {
            lastUpdateTimestamp: '',
            nickName: '',
            tokenType: iframeResponse.financialTokenType === 'CC' ? 'CC' : 'ACH',
            paymentAccountId: iframeResponse.financialTokenId,
            creditCard:
              iframeResponse.financialTokenType === 'CC'
                ? {
                    cardNumber: iframeResponse.cardNumber,
                    cardType: iframeResponse.cardBrand,
                    expirationStatus: CreditCardExpirationStatusType.NOT_EXPIRED,
                    cardExpiry: iframeResponse.cardExpiryDate
                  }
                : null,
            achWithdrawal:
              iframeResponse.financialTokenType === 'ACH'
                ? {
                    routingNumber: iframeResponse.bankRoutingNumber,
                    accountNumber: iframeResponse.bankAccountNumber,
                    accountType:
                      iframeResponse.bankAccountType === 'CHECKING'
                        ? PaymentMethodAccountType.CHECKING
                        : PaymentMethodAccountType.SAVINGS,
                    accountUse:
                      iframeResponse.bankAccountUse === 'PERSONAL'
                        ? PaymentMethodAccountUseType.PERSONAL
                        : PaymentMethodAccountUseType.BUSINESS,
                    financialInstitution: ''
                  }
                : null
          },
          scheduledPayments: [],
          automaticPayments: []
        }
      })
    );

    //On Save click opens add payment success modal refering to DRE-36032 story
    this.modalService.openCloseOthers('addPaymentSuccessModalId');
  };

  ngOnInit() {
    this.spinner.start({
      blockActions: true
    });

    this.primaryButtonName = this.copyService.getCopy('shared.saveBtn');

    this.store
      .select(BrandSelectors.selectExperienceId)
      .pipe(take(1))
      .subscribe(val => (this.experienceId = val));

    this.isHsPolicy$ = this.store.select(BillAccountsSelectors.selectIsSelectedBillPolicyHomesite);

    this.store
      .select(BrandSelectors.selectPartnerId)
      .pipe((take(1), map((val: string) => (this.partnerId = val))));
  }

  savePaymentMethod() {
    this.handleGetAfeToken();
  }

  closeModal() {
    this.modalService.closeAll();
  }

  handleGetAfeToken = () => {
    try {
      //The below needs to be uncommented
      this.cardEntryAdapterRef.getToken({
        afePartnerId: '529', //this.partnerId,
        afeSourceId: 'connect',
        afeTraceId: this.sessionId,
        customerId: '4565878945',
        customerSystemName: 'ECID',
        policySourceSystem: 'PL_Horison',
        usageType: 'SINGLE'
      });
    } catch (error) {
      console.log('Error in handleGetAfeToken:', error);
    }
  };
}
